import script from "./HollowDotsSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./HollowDotsSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./HollowDotsSpinner.vue?vue&type=style&index=0&id=31040584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31040584"]])

export default __exports__